import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 3v4a1 1 0 0 0 1 1h4","key":"svg-0"}],["path",{"d":"M12 21h-5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v3.5","key":"svg-1"}],["path",{"d":"M9 9h1","key":"svg-2"}],["path",{"d":"M9 13h6","key":"svg-3"}],["path",{"d":"M9 17h3","key":"svg-4"}],["path",{"d":"M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5","key":"svg-5"}]]

const IconFileTextSpark = createReactComponent('outline', 'file-text-spark', 'FileTextSpark', __iconNode);

export default IconFileTextSpark;